import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Button, ItemPage } from '../common';
import { getLangValue } from '../common/functions';
import { Dialog } from '../common/Dialog';
import { Info } from '../common/Icons';

const Box = styled.div`
    border-radius: 5px;
    display: grid;
    width: 20em;
    padding: 1em;
    color: ${(props) => props.theme.primary};
    place-content: space-between;

    @media (max-width: ${(props) => props.theme.mobileLimit}) {
       width: 100%;
       place-content: normal;
    }
`;

const BoxContent = styled.div`
    margin: 1em;
    grid-row: 1;
`;

const BoxIcon = styled.div`
    float: right;
    margin: 0.5em;
`;

const BoxTitleContainer = styled.div`
    place-content: space-evenly;
`;

const BoxTitle = styled.div`
    font-weight: bold;
    font-size: 1.2em;
`;

const BoxText = styled.div`
`;

const BoxButton = styled(Button)`
    grid-row: 2;
`;

const InvertedBoxButton = styled(Button)`
    grid-row: 2;
    background: #EAEDFA;
    border:  3px solid ${(props) => props.theme.primary};
    color: ${(props) => props.theme.primary};
`;

const Home = ({ lottery, authenticated, slug, cms, onLogin, onRedeem }) => {
    const [authenticatedUserInfoOpen, setAuthenticatedUserInfoOpen] = useState(false);
    const [quickClaimInfoOpen, setQuickClaimInfoOpen] = useState(false);
    const [homeInfos, setHomeInfos] = useState(null);

    useEffect(() => {
        if(!slug || !cms) return;
        const index = cms.claimable_lotteries.findIndex((item) => item.slug === slug);
        if(index === -1) return;
        setHomeInfos(cms.claimable_lotteries[index]['home_infos']);
    }, [slug, cms]);

    console.log('homeInfos', homeInfos);

    return (
        <>
            <ItemPage.Title>{lottery && getLangValue(lottery.names, 'fi')}</ItemPage.Title>
            <ItemPage.Description>
                <ItemPage.Text>
                    {lottery && getLangValue(lottery.descriptions, 'fi')}
                </ItemPage.Text>
            </ItemPage.Description>
            <ItemPage.Actions>
                {authenticated && <Button onClick={onRedeem}>Jatka</Button>}
                {!authenticated && (
                    <Box>
                        <BoxContent>
                            <BoxIcon>
                                <Info onClick={() => setAuthenticatedUserInfoOpen(true)}/>
                            </BoxIcon>

                            <BoxTitle>
                                - Kuukausitilajaalle -
                            </BoxTitle>

                            <BoxText>
                                Kirjaudu sisään asiakasnumerollasi ja rekisteröi arvat voittotilillesi.
                            </BoxText>
                        </BoxContent>

                        <BoxButton
                            onClick={onLogin}
                        >
                            Kirjaudu sisään
                        </BoxButton>

                        <Dialog
                            open={authenticatedUserInfoOpen}
                            onClick={() => setAuthenticatedUserInfoOpen(false)}
                            maxHeight='80vh'
                        >
                            <Dialog.Content>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: homeInfos?.content_authenticated_user
                                    }}
                                >
                                </div>
                            </Dialog.Content>
                            <Dialog.Actions>
                                <Button onClick={() => setAuthenticatedUserInfoOpen(false)}>
                                    Ok
                                </Button>
                            </Dialog.Actions>
                        </Dialog>
                    </Box>
                )}
                {!authenticated && lottery.quick_claim_enabled && (
                    <Box style={{
                        background: '#EAEDFA'
                    }}>
                        <BoxContent>
                            <BoxIcon>
                                <Info onClick={() => setQuickClaimInfoOpen(true)}/>
                            </BoxIcon>

                            <BoxText>
                                Lunasta yksittäisen arvan voitto tai osallistu lisäarvontaan ilman kirjautumista.
                            </BoxText>
                        </BoxContent>
                        <InvertedBoxButton
                            onClick={onRedeem}
                        >
                            Pikalunastus
                        </InvertedBoxButton>

                        <Dialog
                            open={quickClaimInfoOpen}
                            onClick={() => setQuickClaimInfoOpen(false)}
                            maxHeight='80vh'
                        >
                            <Dialog.Content>
                                <Dialog.Text>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: homeInfos?.content_quick_claim_user
                                        }}
                                    >
                                    </div>
                                </Dialog.Text>
                            </Dialog.Content>
                            <Dialog.Actions>
                                <Button onClick={() => setQuickClaimInfoOpen(false)}>
                                    Ok
                                </Button>
                            </Dialog.Actions>
                        </Dialog>
                    </Box>
                )}
            </ItemPage.Actions>
        </>
    );
};

export { Home };
